import type { FramesClient } from "@connect/data/frames/client";
import type { LimitUpgradeStatus, LimitUpgradeSubmission } from "./limit-upgrade-api.types";

// The UI collects/validates DOB as MM/DD/YYYY (validate-limit-upgrade.ts); the wire
// contract wants ISO YYYY-MM-DD.
function toIsoDate(dateOfBirth: string): string {
  const [month, day, year] = dateOfBirth.split("/");
  return `${year}-${month}-${day}`;
}

export async function submitLimitUpgrade(
  client: FramesClient,
  submission: LimitUpgradeSubmission,
): Promise<LimitUpgradeStatus> {
  const { data, error } = await client.POST("/platform/v1/guest-checkout/limit-upgrade", {
    body: {
      amount: submission.amount,
      asset: { code: submission.asset.code },
      dateOfBirth: toIsoDate(submission.dateOfBirth),
      socialSecurityNumberLast4: submission.socialSecurityNumberLast4,
    },
  });

  if (error) {
    if (error.code === "forbidden") {
      return "notEligible";
    }
    if (error.code === "conflict") {
      return "verificationIncomplete";
    }
    throw new Error(error.code);
  }

  return data.data.status;
}

export async function fetchLimitUpgradeStatus(client: FramesClient): Promise<LimitUpgradeStatus> {
  const { data, error } = await client.GET("/platform/v1/partner/customer/current");

  if (error) {
    throw new Error(error.code);
  }

  const { limitUpgradeStatus } = data.customer;

  if (limitUpgradeStatus === null) {
    throw new Error("no_limit_upgrade_session");
  }

  return limitUpgradeStatus;
}
